import { AccreditationIndividual } from "@/models/accreditation";
import { create } from "zustand";

interface AccreditationStore {
  createGroupOpen: boolean;
  setCreateGroupOpen: (open: boolean) => void;
  createGroupFromTemplateOpen: boolean;
  setCreateGroupFromTemplateOpen: (open: boolean) => void;
  allocateTicketsOpen: boolean;
  setAllocateTicketsOpen: (open: boolean) => void;
  groupSettingsOpen: boolean;
  setGroupSettingsOpen: (open: boolean) => void;
  createIndividualOpen: boolean;
  setCreateIndividualOpen: (open: boolean) => void;
  individual: AccreditationIndividual;
  setIndividual: (individual: AccreditationIndividual) => void;
  requestPaymentIndividual: AccreditationIndividual | undefined;
  setRequestPaymentIndividual: (
    individual: AccreditationIndividual | undefined
  ) => void;
  bulkActionsLoading: boolean;
  setBulkActionsLoading: (loading: boolean) => void;
  groupToEdit: AccreditationIndividual | null | undefined;
  setGroupToEdit: (
    groupToEdit: AccreditationIndividual | null | undefined
  ) => void;
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
  sendEmailOpen: boolean;
  setSendEmailOpen: (open: boolean) => void;
  selectedIndividualViewMode: "Table" | "Sheet";
  setSelectedIndividualViewMode: (mode: "Table" | "Sheet") => void;

  // Emails
  replyToEmailOpen: boolean;
  setReplyToEmailOpen: (open: boolean) => void;
}

export const useAccreditationStore = create<AccreditationStore>((set) => ({
  createGroupOpen: false,
  setCreateGroupOpen: (open: boolean) => set({ createGroupOpen: open }),
  createGroupFromTemplateOpen: false,
  setCreateGroupFromTemplateOpen: (open: boolean) =>
    set({ createGroupFromTemplateOpen: open }),
  allocateTicketsOpen: false,
  setAllocateTicketsOpen: (open: boolean) => set({ allocateTicketsOpen: open }),
  groupSettingsOpen: false,
  setGroupSettingsOpen: (open: boolean) => set({ groupSettingsOpen: open }),
  createIndividualOpen: false,
  setCreateIndividualOpen: (open: boolean) =>
    set({ createIndividualOpen: open }),
  individual: {} as AccreditationIndividual,
  setIndividual: (individual: AccreditationIndividual) => set({ individual }),
  requestPaymentIndividual: undefined,
  setRequestPaymentIndividual: (
    individual: AccreditationIndividual | undefined
  ) => set({ requestPaymentIndividual: individual }),
  bulkActionsLoading: false,
  setBulkActionsLoading: (loading: boolean) =>
    set({ bulkActionsLoading: loading }),
  groupToEdit: null,
  setGroupToEdit: (groupToEdit: AccreditationIndividual | null | undefined) =>
    set({ groupToEdit }),
  searchOpen: false,
  setSearchOpen: (open: boolean) => set({ searchOpen: open }),
  sendEmailOpen: false,
  setSendEmailOpen: (open: boolean) => set({ sendEmailOpen: open }),
  selectedIndividualViewMode: "Table",
  setSelectedIndividualViewMode: (mode: "Table" | "Sheet") =>
    set({ selectedIndividualViewMode: mode }),

  // Emails
  replyToEmailOpen: false,
  setReplyToEmailOpen: (open: boolean) => set({ replyToEmailOpen: open }),
}));
